import { Input } from '@kognitos/lattice';
import type { TimeInputProps } from '../types';

/**
 * Time input component for time selection
 *
 * Renders a native time picker that handles times in HH:mm format.
 * Converts between browser time format and TypeTimeOfDay structure.
 *
 * @param props - Component props
 * @returns JSX element containing the time input field
 */
export function TimeInput({
  name,
  value,
  onChange,
  error,
  required,
  placeholder,
  disabled,
}: TimeInputProps) {
  return (
    <Input
      id={name}
      name={name}
      type="time"
      value={value}
      onChange={e => onChange(e.target.value)}
      placeholder={placeholder}
      required={required}
      aria-invalid={!!error}
      className={
        error ? 'border-destructive focus-visible:ring-destructive' : ''
      }
      disabled={disabled}
      data-testid={`input-${name}`}
    />
  );
}
